import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useEffect, useState } from 'react'
import {
	appCreateMembership,
	appCreateSanstha,
	appDeleteMembership,
	appDeleteSanstha,
	appGetAllSanstha,
	appGetSansthaById,
	appUpdateMembership,
	appUpdateSanstha,
	uploadSansthaImage,
} from '../../store/sanstha'
import Select from 'react-select'
import swal from 'sweetalert'
import { toast } from 'react-toastify'

const HONORARY_MEMBERSHIP_TYPES = [
	'Free( Honorary) with voting right',
	'Family member ( free and without voting right)',
]

const isHonoraryMembership = membershipType => HONORARY_MEMBERSHIP_TYPES.includes(membershipType)

const PAYMENT_DETAIL_FIELDS = [
	{ name: 'upi_id', label: 'UPI ID' },
	{ name: 'account_name', label: 'Account Name' },
	{ name: 'account_number', label: 'Account Number' },
	{ name: 'bank_name', label: 'Bank Name' },
	{ name: 'branch_name', label: 'Branch Name' },
	{ name: 'ifsc_code', label: 'IFSC Code' },
]

function TableFilter() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const params = useParams()
	const [page, setPage] = useState(params.page || 1)
	const [showModal, setShowModal] = useState(false)
	const [editMode, setEditMode] = useState(false)
	const [editSansthaId, setEditSansthaId] = useState(null)
	const isdeleted = useSelector(state => state?.sansthaReducer?.isdeleted)
	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')
	const sansthaDetails = useSelector(state => state.sansthaReducer.sansthaDetails)

	useEffect(() => {
		// dispatch(appGetAllSanstha({page:1, limit:1000, sanstha: id }));
		//dispatch(appGetAllSanstha({ page: 1, limit: 1000 }));
		dispatch(appGetSansthaById(sansthaId || permissionOfSanstha))
	}, [dispatch, sansthaId || permissionOfSanstha])

	const Formik = useFormik({
		initialValues: {
			membershipType: '',
			membershipfee: '',
			honoraryReason: '',
			// qr_code: "",
			upi_id: sansthaDetails?.upi_id || '',
			account_name: sansthaDetails?.account_name || '',
			account_number: sansthaDetails?.account_number || '',
			bank_name: sansthaDetails?.bank_name || '',
			branch_name: sansthaDetails?.branch_name || '',
			ifsc_code: sansthaDetails?.ifsc_code || '',
		},
		enableReinitialize: true,
		validationSchema: Yup.object({
			membershipType: Yup.string().required('Select duration'),
			upi_id: Yup.string().when([], {
				is: () => !showModal,
				then: Yup.string()
					.required('UPI ID is required')
					.matches(/^[\w.-]+@[\w.-]+$/, 'Enter a valid UPI ID'),
				otherwise: Yup.string().notRequired(),
			}),
			account_name: Yup.string().when([], {
				is: () => !showModal,
				then: Yup.string().required('Account name is required'),
				otherwise: Yup.string().notRequired(),
			}),
			account_number: Yup.string().when([], {
				is: () => !showModal,
				then: Yup.string().required('Account number is required'),
				otherwise: Yup.string().notRequired(),
			}),
			bank_name: Yup.string().when([], {
				is: () => !showModal,
				then: Yup.string().required('Bank name is required'),
				otherwise: Yup.string().notRequired(),
			}),
			branch_name: Yup.string().when([], {
				is: () => !showModal,
				then: Yup.string().required('Branch name is required'),
				otherwise: Yup.string().notRequired(),
			}),
			ifsc_code: Yup.string().when([], {
				is: () => !showModal,
				then: Yup.string().required('IFSC code is required'),
				otherwise: Yup.string().notRequired(),
			}),
			honoraryReason: Yup.string().when('membershipType', {
				is: isHonoraryMembership,
				then: Yup.string().required('Honorary reason is required'),
				otherwise: Yup.string().notRequired(),
			}),

			membershipfee: Yup.number().when('membershipType', {
				is: val => !isHonoraryMembership(val),
				then: Yup.number().required('Membership fee is required'),
				otherwise: Yup.number()
					.transform((value, originalValue) => (originalValue === '' ? undefined : value))
					.notRequired(),
			}),
		}),
		// onSubmit: (values) => {
		//   console.log(values);

		//   const membershipPayload = {
		//     membershipType: values.membershipType,
		//     membershipfee: values.membershipfee,
		//   };
		// console.log(membershipPayload)
		//   const basePayload = {
		//     sansthaId: sansthaDetails?._id,
		//     membership: membershipPayload,
		//   };
		// console.log(basePayload)
		//   if (editMode && editSansthaId ) {
		//     const payload = {
		//       ...basePayload,
		//       membershipId: editSansthaId,
		//     };
		// console.log(payload)
		//     dispatch(appUpdateMembership(payload)).then(() => {
		//       dispatch(appGetSansthaById(sansthaDetails?._id));
		//     });
		//   } else {
		//     console.log(basePayload)
		//     dispatch(appCreateMembership(basePayload)).then(() => {
		//       dispatch(appGetSansthaById(sansthaDetails?._id));
		//      });
		//   }

		//   setShowModal(false);
		//   setEditMode(false);
		//   setEditSansthaId(null);
		//   // setEditMembershipId(null);
		//   Formik.resetForm();
		// }

		onSubmit: async values => {
			const selectedType = values.membershipType

			const existingTypes = sansthaDetails?.membership?.map(m => m.membershipType) || []
			const isDuplicate = existingTypes.includes(selectedType)

			if (!editMode && isDuplicate) {
				toast.error(`${selectedType} membership already exists.`)
				return
			}
			const isHonorary = isHonoraryMembership(selectedType)

			const membershipPayload = {
				membershipType: selectedType,
				...(isHonorary
					? { honoraryReason: values.honoraryReason }
					: { membershipfee: values.membershipfee }),
			}

			const basePayload = {
				sansthaId: sansthaDetails?._id,
				membership: membershipPayload,
			}
			// console.log(basePayload, "basePayload");

			try {
				if (editMode && editSansthaId) {
					const payload = {
						...basePayload,
						membershipId: editSansthaId,
					}
					//  console.log(payload, "payload");

					dispatch(appUpdateMembership(payload)).then(() => {
						dispatch(appGetSansthaById(sansthaDetails?._id))
					})
				} else {
					//  console.log(basePayload);
					dispatch(appCreateMembership(basePayload)).then(() => {
						dispatch(appGetSansthaById(sansthaDetails?._id))
					})
				}

				// Refresh data after success
				//dispatch(appGetSansthaById(sansthaDetails?._id));

				// Reset modal + form
				setShowModal(false)
				setEditMode(false)
				setEditSansthaId(null)
				Formik.resetForm()
			} catch (error) {
				toast.error('Something went wrong. Please try again.')
				console.error('Membership create/update error:', error)
			}
		},
	})

	// useEffect(() => {
	//   if (sansthaDetails) {
	//     // const selectedLanguage = Array.isArray(languageData) ? languageData.find(l => l._id === id) : languageData;
	//     if (sansthaDetails) {
	//       Formik.setFieldValue("upi_id", sansthaDetails.upi_id);
	//     }
	//   }
	// }, [sansthaDetails]);

	const handleEditMembership = sanstha => {
		//   console.log(sanstha);
		setEditMode(true)
		setEditSansthaId(sanstha?._id || null)

		Formik.setValues({
			...Formik.values,
			membershipType: sanstha?.membershipType || '',
			membershipfee: sanstha?.membershipfee || '',
			honoraryReason: sanstha.honoraryReason || '',
		})

		setShowModal(true)
	}

	// useEffect(() => {
	//   if (isdeleted) {
	//     dispatch(appGetSansthaById(sansthaDetails?._id));
	//   }
	// }, [isdeleted, dispatch]);

	const handleDeleteMembership = membershipId => {
		//  console.log(membershipId);
		swal({
			title: 'Are you sure?',
			text: 'You want to delete this Membership?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then(willDelete => {
			if (willDelete) {
				dispatch(
					appDeleteMembership({
						sansthaId: sansthaDetails?._id,
						membershipId,
					}),
				).then(() => {
					dispatch(appGetSansthaById(sansthaDetails?._id))
				})
			}
		})
	}

	const handleAddNewMembership = () => {
		setEditMode(false)
		setEditSansthaId(null)
		Formik.resetForm()
		Formik.setValues({
			...Formik.values,
			membershipType: '',
			membershipfee: '',
			honoraryReason: '',
		})
		setShowModal(true)
	}

	const handlesaveupiid = () => {
		const payload = {
			id: sansthaDetails?._id,
			upi_id: Formik.values.upi_id,
			account_name: Formik.values.account_name,
			account_number: Formik.values.account_number,
			bank_name: Formik.values.bank_name,
			branch_name: Formik.values.branch_name,
			ifsc_code: Formik.values.ifsc_code,
		}

		dispatch(appUpdateSanstha(payload)).then(() => {
			dispatch(appGetSansthaById(sansthaDetails?._id))
		})
	}

	return (
		<div>
			<div className="mb-3 d-flex justify-content-end align-items-center">
				<div>
					<button className="btn btn-primary" onClick={handleAddNewMembership}>
						<i className="far fa-plus"></i> Add New Membership & Payment
					</button>
				</div>
			</div>
			<div className="card mb-3">
				<div className="card-body">
					<h4 className="mb-1" style={{ fontWeight: 400, color: '#666' }}>
						Payment Details
					</h4>
					<p className="mb-3 text-muted">
						Fill all fields and save the bank details used for membership payments.
					</p>
					<div className="d-flex flex-wrap align-items-end" style={{ gap: '16px 36px' }}>
						{PAYMENT_DETAIL_FIELDS.map(field => (
							<div
								className="form-group mb-0"
								key={field.name}
								style={{ position: 'relative', flex: '1 1 210px' }}
							>
								<label>{field.label} *</label>
								<input
									type="text"
									className="form-control"
									name={field.name}
									value={Formik.values[field.name] || ''}
									onChange={Formik.handleChange}
									onBlur={Formik.handleBlur}
								/>
								{Formik.touched[field.name] && Formik.errors[field.name] && (
									<div
										className="text-danger"
										style={{ position: 'absolute', top: '100%', fontSize: '12px' }}
									>
										{Formik.errors[field.name]}
									</div>
								)}
							</div>
						))}
						<div className="d-flex justify-content-end" style={{ flex: '1 1 210px' }}>
							<button
								className="btn btn-labeled btn-primary"
								onClick={async () => {
									const errors = await Formik.validateForm()
									const touchedFields = PAYMENT_DETAIL_FIELDS.reduce((acc, field) => {
										acc[field.name] = true
										return acc
									}, {})
									Formik.setTouched(touchedFields)
									const hasPaymentErrors = PAYMENT_DETAIL_FIELDS.some(field => errors[field.name])
									if (!hasPaymentErrors) {
										handlesaveupiid()
									}
								}}
								type="button"
							>
								<span className="btn-label">
									<i className="fa fa-check"></i>
								</span>
								Save Payment Details
							</button>
						</div>
					</div>
				</div>
			</div>
			<div className="table-responsive">
				<table className="table table-bordered table-hover">
					<thead className="">
						<tr>
							<th>Sr. No.</th>
							<th>Membership Duration </th>
							<th>Membership Fee/Reason</th>

							<th>Actions</th>
						</tr>
					</thead>
					<tbody>
						{sansthaDetails?.membership && sansthaDetails.membership.length > 0 ? (
							sansthaDetails.membership.map((membership, index) => (
								<tr key={membership._id || index}>
									<td>{index + 1}</td>
									<td>{membership.membershipType}</td>
									{/* <td>{membership.membershipfee}</td> */}
									<td>
										{membership.membershipType === 'Free( Honorary) with voting right' ||
										membership.membershipType === 'Family member ( free and without voting right)'
											? membership.honoraryReason
											: membership.membershipfee}
									</td>
									<td>
										<button
											className="btn btn-sm btn-primary mr-2"
											title="Edit"
											onClick={() => handleEditMembership(membership)}
										>
											<i className="far fa-edit"></i>
										</button>
										<button
											className="btn btn-sm btn-danger"
											title="Delete"
											onClick={() => handleDeleteMembership(membership?._id)}
										>
											<i className="far fa-trash-alt"></i>
										</button>
									</td>
								</tr>
							))
						) : (
							<tr>
								<td colSpan="3" className="text-center">
									No membership data available
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>

			{/* Membership and Payment Details Creation Modal */}
			{showModal && (
				<div
					className="modal fade show"
					style={{
						display: 'block',
						backgroundColor: 'rgba(0,0,0,0.5)',
						marginTop: '35px',
					}}
				>
					<div className="modal-dialog modal-lg" style={{ marginTop: '200px' }}>
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">
									{editMode
										? 'Edit Membership type and Payment Details(UPI ID)'
										: 'Create New Membership type and Payment Details(UPI ID)'}
								</h5>
								<button
									type="button"
									className="close"
									onClick={() => {
										setShowModal(false)
										setEditMode(false)
										setEditSansthaId(null)
										Formik.resetForm()
									}}
								>
									<span>&times;</span>
								</button>
							</div>
							<div className="modal-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
								<form onSubmit={Formik.handleSubmit}>
									<div className="row">
										{/* Membership Duration */}
										<div className="col-md-6">
											<div className="form-group">
												<label>Membership Duration *</label>
												<select
													className="form-control"
													name="membershipType"
													value={Formik.values.membershipType}
													onChange={Formik.handleChange}
													onBlur={Formik.handleBlur}
												>
													<option value="">Select Duration</option>
													<option value="Monthly">Monthly</option>
													<option value="Yearly">Yearly</option>
													<option value="Lifetime">Lifetime</option>
													<option value="Free( Honorary) with voting right">
														Free( Honorary) with voting right
													</option>
													<option value="Family member ( free and without voting right)">
														Family member ( free and without voting right)
													</option>
												</select>
												{Formik.touched.membershipType && Formik.errors.membershipType ? (
													<div className="text-danger">{Formik.errors.membershipType}</div>
												) : null}
											</div>
										</div>

										{/* Membership Fee */}
										<div className="col-md-6">
											<div className="form-group">
												{Formik.values.membershipType === 'Free( Honorary) with voting right' ||
												Formik.values.membershipType ===
													'Family member ( free and without voting right)' ? (
													<>
														<label> Reason *</label>
														<input
															type="text"
															className="form-control"
															name="honoraryReason"
															value={Formik.values.honoraryReason || ''}
															onChange={Formik.handleChange}
															onBlur={Formik.handleBlur}
														/>
														{Formik.touched.honoraryReason && Formik.errors.honoraryReason ? (
															<div className="text-danger">{Formik.errors.honoraryReason}</div>
														) : null}
													</>
												) : (
													<>
														<label>Membership Fee *</label>
														<input
															type="number"
															className="form-control"
															name="membershipfee"
															value={Formik.values.membershipfee}
															onChange={Formik.handleChange}
															onBlur={Formik.handleBlur}
														/>
														{Formik.touched.membershipfee && Formik.errors.membershipfee ? (
															<div className="text-danger">{Formik.errors.membershipfee}</div>
														) : null}
													</>
												)}
											</div>
										</div>
										{/* <div className="col-md-6">
                       <div className="form-group">
                         <label>Membership Fee *</label>
                         <input
                           type="number"
                           className="form-control"
                           name="membershipfee"
                           value={Formik.values.membershipfee}
                           onChange={Formik.handleChange}
                           onBlur={Formik.handleBlur}
                         />
                         {Formik.touched.membershipfee &&
                         Formik.errors.membershipfee ? (
                           <div className="text-danger">
                             {Formik.errors.membershipfee}
                           </div>
                         ) : null}
                       </div>
                     </div> */}

										{/* <div className="col-md-6">
                       <div className="form-group">
                         <label>UPI ID *</label>
                         <input
                           type="text"
                           className="form-control"
                           name="upi_id"
                           value={Formik.values.upi_id}
                           onChange={Formik.handleChange}
                           onBlur={Formik.handleBlur}
                         />
                         {Formik.touched.upi_id && Formik.errors.upi_id ? (
                           <div className="text-danger">
                             {Formik.errors.upi_id}
                           </div>
                         ) : null}
                       </div>
                     </div>
 
                     <div className="col-md-6">
                       <ImageUpload
                         uploadFunction={uploadSansthaImage}
                         fieldName="qr_code"
                         value={Formik.values.qr_code}
                         onChange={(value) =>
                           Formik.setFieldValue("qr_code", value)
                         }
                         error={
                           Formik.touched.qr_code && Formik.errors.qr_code
                             ? Formik.errors.qr_code
                             : null
                         }
                         label="QR Code *"
                       />
                     </div> */}
									</div>

									<div className="modal-footer">
										<button
											className="btn btn-labeled btn-success"
											type="submit"
											onClick={Formik.handleSubmit}
										>
											<span className="btn-label">
												<i className="fa fa-check"></i>
											</span>
											{editMode ? 'Update' : 'Create'}
										</button>
										<button
											className="btn btn-labeled btn-secondary ml-2"
											type="button"
											onClick={() => {
												setShowModal(false)
												setEditMode(false)
												setEditSansthaId(null)
												Formik.resetForm()
											}}
										>
											<span className="btn-label">
												<i className="fa fa-times"></i>
											</span>
											Cancel
										</button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	)
}

export default TableFilter
